import * as angular from 'angular';
import {DataHubService} from "./DataHubModule";
import {UserStorageDto} from "../model/UserStorageDto";
import {ConfigService} from "./ConfigModule";

export class UserActivityService {
    store = new Array<UserStorageDto>();

    constructor(private $dataHub: DataHubService,
                $location: ng.ILocationService,
                $rootScope: ng.IRootScopeService) {
        $dataHub.on('userActivityForceRefresh', () => window.location.reload());
        $dataHub.on('userActivityForceClose', () => window.close());

        $dataHub.onConnected(this.update);

        $rootScope.$on('$locationChangeSuccess', this.update);

        // watch document.title
        new MutationObserver(this.update).observe(
            document.querySelector('title'),
            { subtree: true, characterData: true }
        );

    }

    private update = () => {
        this.pushUpdate(window.document.title, window.location.pathname + window.location.search);
    };

    private pushUpdate = (title: string, url: string) => {
        if (!this.$dataHub.isConnected) return;
        let data = {
            title: title,
            url: url,
            version: window["version"]
        };
        this.$dataHub.invoke('userActivityUpdate', data);
    }

}

export default angular.module('services.userActivity', [])
    .service('$userActivity', UserActivityService)
    .name;
